import { render, staticRenderFns } from "./KhatmaItem.vue?vue&type=template&id=0794e3d2&scoped=true&"
import script from "./KhatmaItem.vue?vue&type=script&lang=js&"
export * from "./KhatmaItem.vue?vue&type=script&lang=js&"
import style0 from "./KhatmaItem.vue?vue&type=style&index=0&id=0794e3d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0794e3d2",
  null
  
)

export default component.exports